import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@material-ui/core';
import AddOrRemoveTableProps from 'types/forms/AddOrRemoveTableProps';
import { AgeRangeConfigForm } from 'forms/schemas/SplashForm';
import 'styles/components/AddOrRemoveTable.scss';
import { AgeRangeConfig } from 'types/models/Splash';

export default ({ splash, onAddRow, onDeleteRow, onUpdateRow }: AddOrRemoveTableProps): JSX.Element => {
  const { t } = useTranslation();

  const Row = ({ config }: { config?: AgeRangeConfig }): JSX.Element => {
    const formik = useFormik({
      initialValues: {
        id: config?.id ?? '',
        fromAge: config?.fromAge ?? '',
        toAge: config?.toAge ?? '',
      },
      validationSchema: AgeRangeConfigForm(t),
      onSubmit: () => console.log('test'),
    });

    return (
      <>
        <form>
          <div className="row-container">
            <div className="input-container">
              <TextField
                type="number"
                margin="dense"
                id="fromAge"
                name="fromAge"
                label={t('components.from')}
                InputProps={{ inputProps: { min: 1 } }}
                value={formik.values.fromAge}
                onChange={formik.handleChange}
              />
              <TextField
                type="number"
                margin="dense"
                id="toAge"
                name="toAge"
                label={t('components.to')}
                InputProps={{ inputProps: { min: formik.values.fromAge } }}
                value={formik.values.toAge}
                error={formik.touched.toAge && Boolean(formik.errors.toAge)}
                helperText={formik.touched.toAge && formik.errors.toAge}
                onChange={formik.handleChange}
              />
            </div>
            <div className="buttons-container">
              {config?.id ? (
                <>
                  <Button variant="outlined" color="primary" onClick={() => onUpdateRow(formik.values)}>
                    {t('edit')}
                  </Button>
                  <Button variant="outlined" color="primary" onClick={() => onDeleteRow(formik.values)}>
                    {t('components.delete')}
                  </Button>
                </>
              ) : (
                <Button variant="outlined" color="primary" onClick={() => onAddRow(formik.values)}>
                  {t('components.save')}
                </Button>
              )}
            </div>
          </div>
        </form>
      </>
    );
  };

  return (
    <div className="container">
      <div>
        {splash.ageRangeConfigs.length > 0 && (
          <>
            {splash.ageRangeConfigs.map((config, index) => (
              <Row key={index} config={config} />
            ))}
          </>
        )}
        <Row />
      </div>
    </div>
  );
};
